import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MAISONS } from "../data/maisons";
import { useAuth } from "../context/AuthContext";

const CardBody = ({ m }) => (
  <>
    <div className="overflow-hidden aspect-[4/3]">
      <img
        src={m.image}
        alt={`${m.name} — ${m.category}`}
        loading="lazy"
        className="w-full h-full object-cover"
      />
    </div>
    <div className="p-5">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-mutedink mb-1.5">
        {m.category}
      </p>
      <h3 className="font-serif text-lg text-ink">{m.name}</h3>
      <p className="mt-2 text-sm text-mutedink leading-relaxed">{m.aesthetic}</p>
      {m.path && (
        <p className="mt-3 inline-flex items-center gap-1.5 text-xs text-oxblood">
          View brand
          <ArrowUpRight className="w-3.5 h-3.5" />
        </p>
      )}
    </div>
  </>
);

const cardCls =
  "bg-white border border-ink/10 hover:border-oxblood/40 transition-colors duration-300 block";

export const Portfolio = () => {
  const { user } = useAuth();
  // Private projects are only visible to the signed-in back-office user
  const visible = MAISONS.filter((m) => !m.private || user);
  return (
  <section
    id="maisons"
    data-testid="portfolio-section"
    className="px-6 py-16 sm:py-20 border-t border-ink/10"
  >
    <div className="max-w-5xl mx-auto">
      <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-ink mb-10">
        Our Portfolio
      </h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="maisons-grid">
        {visible.map((m) =>
          m.path ? (
            <Link key={m.id} to={m.path} data-testid={`maison-card-${m.id}`} className={cardCls}>
              <CardBody m={m} />
            </Link>
          ) : (
            <article key={m.id} data-testid={`maison-card-${m.id}`} className={cardCls}>
              <CardBody m={m} />
            </article>
          ),
        )}
      </div>
    </div>
  </section>
  );
};
